module.exports = __webpack_public_path__ + "assets/fonts/filter.50c0b9c0.svg";